import apiSlice from '../api/api.slice';

export const likeApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    likePost: builder.mutation<any, string>({
      query: (postId) => ({
        url: `/api/v1/like/create`,
        method: 'POST',
        body: {
          postId,
        },
      }),
    }),
    unlikePost: builder.mutation<any, string>({
      query: (postId) => ({
        url: `/api/v1/like/delete?postId=${postId}`,
        method: 'DELETE',
      }),
    }),
  }),
});

apiSlice.enhanceEndpoints({
  addTagTypes: ['Like'],
  endpoints: {
    likePost: {
      invalidatesTags: ['Post'],
    },
    unlikePost: {
      invalidatesTags: ['Post'],
    },
  },
});

export const { useLikePostMutation, useUnlikePostMutation } = likeApiSlice;
